export default {
  Title: "Tra cứu kiến nghị",
  SearchPlaceholder: "Tìm kiếm theo tiêu đề, nội dung kiến nghị",
  DetailButtonText: "Xem chi tiết",
  RequestContentText: "Nội dung kiến nghị",
  RequestAnswerText: "Nội dung trả lời",
  ContentAttachmentText: "Tài liệu đính kèm kiến nghị",
  AnswerAttachmentText: "Tài liệu đính kèm trả lời",
  ExportTitle: "Danh sách kết quả tra cứu kiến nghị",
  SheetName: "Kết quả tra cứu",
  NoDataText: "Không có dữ liệu",
  NotFoundText: "Không tìm thấy kết quả phù hợp",
  Responsibler: "Phụ trách trả lời",
  ResponsiblerName: "Phụ trách/Đơn vị trả lời",
};
